import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const HardwareInstallation = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Hardware Installation & Setup</h1>
            <p className="service-description">
              Professional hardware installation services for all your IT equipment needs. 
              From workstations to servers, we ensure optimal setup and configuration.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>What We Offer</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🖥️</div>
                    <h3>Desktop & Workstation Setup</h3>
                  </div>
                  <p>Complete assembly, configuration, and optimization of desktop computers and workstations for maximum performance.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Desktop & Workstation Setup</div>
                    <ul className="popover-list">
                      <li>PC assembly, OS installation and activation</li>
                      <li>Driver, BIOS/UEFI updates and security hardening</li>
                      <li>Domain join, user profiles and policy setup</li>
                      <li>Performance tuning and startup optimization</li>
                      <li>Multi‑monitor and docking configuration</li>
                      <li>Data migration from old systems</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🖨️</div>
                    <h3>Peripheral Installation</h3>
                  </div>
                  <p>Professional setup of printers, scanners, monitors, and other peripheral devices with proper driver installation.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Peripheral Installation</div>
                    <ul className="popover-list">
                      <li>Printers, scanners and MFP setup</li>
                      <li>Monitors, docks, projectors and KVMs</li>
                      <li>Keyboards, mice, webcams and headsets</li>
                      <li>Network printers and print queues</li>
                      <li>Driver/firmware installation and testing</li>
                      <li>Cable management and ergonomics</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">💾</div>
                    <h3>Storage Solutions</h3>
                  </div>
                  <p>Installation and configuration of hard drives, SSDs, and external storage systems with data migration services.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Storage Solutions</div>
                    <ul className="popover-list">
                      <li>Internal SSD/HDD install and cloning</li>
                      <li>RAID setup and health monitoring</li>
                      <li>External storage and NAS configuration</li>
                      <li>Partitioning, formatting and encryption</li>
                      <li>Backup strategy and scheduling</li>
                      <li>Data recovery and integrity checks</li>
                    </ul>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔌</div>
                    <h3>Component Upgrades</h3>
                  </div>
                  <p>RAM upgrades, graphics card installation, and other hardware enhancements to boost system performance.</p>
                  <div className="feature-popover">
                    <div className="popover-title">Component Upgrades</div>
                    <ul className="popover-list">
                      <li>RAM capacity upgrades and dual‑channel tuning</li>
                      <li>GPU installs, PSU sizing and drivers</li>
                      <li>CPU upgrades, cooling and thermal paste</li>
                      <li>PSU replacements and cable routing</li>
                      <li>Wi‑Fi/Bluetooth and capture cards</li>
                      <li>Firmware updates and stress testing</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Why Choose Our Installation Services?</h2>
                <ul className="benefits-list">
                  <li>✓ Certified technicians with extensive experience</li>
                  <li>✓ Comprehensive testing and quality assurance</li>
                  <li>✓ On-site and remote installation options</li>
                  <li>✓ 8 X 6 post-installation support</li>
                  <li>✓ Warranty protection on all hardware purchase from Sysmaco</li>
                  <li>✓ Competitive pricing with transparent quotes</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Response Time:</span>
                  <span className="highlight-value">Same Day</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Product Warranty:</span>
                  <span className="highlight-value">12 Months</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Support:</span>
                  <span className="highlight-value">8 X 6</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Certification:</span>
                  <span className="highlight-value">CompTIA A+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default HardwareInstallation;
